import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const SelectableTableRow = ({
    isSelected,
    classNameCallback,
    style,
    onRowClick,
    rowData,
    cellRenderCallback,
    className,
    troBookDataTestId,
}) => (
    <div
        tabIndex="-1"
        data-test-id={troBookDataTestId}
        className={classNameCallback(isSelected, className)}
        role="row"
        style={style}
        onClick={() => onRowClick(rowData.id)}
    >
        {Object.keys(rowData).map(rowKey => cellRenderCallback(rowKey, rowData[rowKey]))}
        {isSelected && <i className="pink-arrow-icon" />}
    </div>
);

SelectableTableRow.defaultProps = {
    isSelected: false,
    troBookDataTestId: '',
    classNameCallback: (isSelected, className) => `${className} ${isSelected ? 'selected' : ''}`,
    style: {},
    rowData: {},
    onRowClick: () => {},
    cellRenderCallback: (rowKey, value) =>
        rowKey !== 'id' && <Fragment key={rowKey}>{value}</Fragment>,
    className: '',
};

SelectableTableRow.propTypes = {
    isSelected: PropTypes.bool,
    troBookDataTestId: PropTypes.string,
    classNameCallback: PropTypes.func,
    style: PropTypes.object,
    rowData: PropTypes.object,
    onRowClick: PropTypes.func,
    cellRenderCallback: PropTypes.func,
    className: PropTypes.string,
};

export default SelectableTableRow;
